export default __webpack_public_path__ + "static/garden_design5-8671e165329ea5cce2a051d633741041.webp";